/**
 * Quick Add to Cart from Product Cards
 */

function quickAddToCart(variantId, productTitle, button) {
  console.log('Quick add clicked!', variantId, productTitle);

  if (!button) return;

  // Prevent double clicks
  if (button.classList.contains('loading')) return;

  // Show loading state
  button.classList.add('loading');
  button.disabled = true;

  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: parseInt(variantId),
        quantity: 1
      }]
    })
  })
  .then(response => {
    console.log('Response:', response.status);
    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }
    return response.json();
  })
  .then(data => {
    console.log('Added to cart:', data);

    // Show success state
    button.classList.remove('loading');
    button.classList.add('success');

    // Change to checkmark
    button.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 8L6.5 11.5L13 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    // Reset after 2 seconds
    setTimeout(() => {
      button.classList.remove('success');
      button.disabled = false;
      button.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      `;
    }, 2000);

    // Refresh cart drawer with updated content
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    } else {
      console.warn('window.refreshCart not available, falling back to old method');
      refreshCartDrawer();
    }

    // Open cart drawer automatically
    const cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer) {
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      cartDrawer.classList.add('active');
      cartDrawer.focus();
      dispatchCustomEvent('cart-drawer:open');
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.classList.remove('loading');
    button.disabled = false;

    // Show error briefly
    button.classList.add('error');
    setTimeout(() => {
      button.classList.remove('error');
    }, 1000);
  });
}

/**
 * Refresh Cart Drawer Content (Legacy fallback)
 * NOTE: Use window.refreshCart() from cart-refresh.js instead
 */
function refreshCartDrawer() {
  const sections = 'cart-drawer,cart-bubble';

  fetch(`/?sections=${sections}`)
    .then(response => response.json())
    .then(data => {
      // Update cart drawer content
      if (data['cart-drawer']) {
        const cartDrawer = document.getElementById('Cart-Drawer');
        if (cartDrawer) {
          const parser = new DOMParser();
          const html = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newInner = html.querySelector('.side-panel-inner');
          const currentInner = cartDrawer.querySelector('.side-panel-inner');
          if (newInner && currentInner) {
            currentInner.innerHTML = newInner.innerHTML;
          }
        }
      }

      // Update cart count bubble
      if (data['cart-bubble']) {
        const cartBubble = document.getElementById('cart-drawer-toggle');
        if (cartBubble) {
          const parser = new DOMParser();
          const html = parser.parseFromString(data['cart-bubble'], 'text/html');
          const newBubble = html.querySelector('.thb-item-count');
          const currentBubble = cartBubble.querySelector('.thb-item-count');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        }
      }

      // Update progress bar
      updateProgressBar();
    })
    .catch(error => {
      console.error('Error refreshing cart drawer:', error);
    });
}

/**
 * Update Progress Bar (Legacy fallback)
 * NOTE: Use window.refreshCart() from cart-refresh.js instead
 */
function updateProgressBar() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const progressBar = document.querySelector('unified-progress-bar');
      if (progressBar) {
        progressBar.dataset.cartTotal = cart.total_price;
        if (progressBar.updateProgress) {
          progressBar.updateProgress();
        } else {
          // Trigger reconnection if component exists
          const total = cart.total_price;
          progressBar.setAttribute('data-cart-total', total);

          // Manually trigger update if the component has loaded
          if (progressBar.connectedCallback) {
            progressBar.connectedCallback();
          }
        }
      }
    })
    .catch(error => {
      console.error('Error updating progress bar:', error);
    });
}
